import script from "./ModalEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditar.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditar.vue?vue&type=style&index=0&id=3083c537&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3083c537"]])

export default __exports__